import { useParams } from "react-router";
import { TagEdit } from "./TagEdit";

export function TagEditPage() {
  const { id } = useParams();

  return <TagEdit id={id} />;
}
